/*
  <cbg-subject-nav> — SEE MORE / SEE LESS for the Subject group.

  Shared by the collection page (sidebar + slide-in panel, via cbg-facets.liquid)
  and the All Collections page. It lives here rather than in cbg-collection.js
  because the All Collections page has no facet form and so doesn't load that file.

  Markup contract: snippets/cbg-subject-nav.liquid
    - .cbg-facets__group--subject          gets the .is-expanded class
    - [data-cbg-more]                      the toggle button, with
                                           data-cbg-more / data-cbg-less labels
*/
if (!customElements.get('cbg-subject-nav')) {
  customElements.define(
    'cbg-subject-nav',
    class CbgSubjectNav extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('.cbg-facets__group--subject');
        this.button = this.querySelector('[data-cbg-more]');
        if (!this.group || !this.button) return;

        this.onToggleClick = this.onToggleClick.bind(this);
        this.button.addEventListener('click', this.onToggleClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onToggleClick);
      }

      onToggleClick() {
        const expanded = this.group.classList.toggle('is-expanded');
        this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.button.textContent = expanded ? this.button.dataset.cbgLess : this.button.dataset.cbgMore;
      }
    }
  );
}
